var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cars_compare__row not-printable"},[_c('DifferencesSwitch'),_vm._l((_vm.items),function(id,i){return _c('VehicleAction',{key:i + '-' + id,attrs:{"vehicle-exists":!!id,"index":i}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }